import { loadHelpCenterContactPageData } from '@aboutyou/legacy-shared/src/pages/HelpCenter/loadHelpCenterPageData'
import { FetchProps } from 'helpers/redial'
import { report } from 'helpers/reporter'

export default {
  fetch: async ({ store, service }: FetchProps) => {
    try {
      const contactPageData = await loadHelpCenterContactPageData(
        service.helpCenter,
        store.localeStore.locale,
      )

      store.helpCenterContactPage.reset({
        ...contactPageData,
        sections: contactPageData.sections ?? [],
      })
    } catch (error) {
      report('failed to load data for help center contact page', { error })
    }
  },
}
